import 'antd/dist/antd.css';
import { StoreProvider } from 'easy-peasy';
import { createClient, Provider } from 'urql';

import '~/assets/splitters.css';
import '~/assets/style.css';
import { clientOptions } from '~/lib/urql';
import { RouterProvider } from '~/routes/RouterProvider';
import { store } from '~/store/store';

import './App.css';
import { LanguageWrapper } from './shared/Layout/LanguageWrapper';

import { ErrorBoundary } from '@sentry/react';

export const App = () => {
    const urqlClient = createClient({
        ...clientOptions,
    });

    return (
        <ErrorBoundary fallback={<p>An error has occurred</p>}>
            <Provider value={urqlClient}>
                <StoreProvider store={store}>
                    <LanguageWrapper>
                        <RouterProvider />
                    </LanguageWrapper>
                </StoreProvider>
            </Provider>
        </ErrorBoundary>
    );
};
